import React from "react";
import { ChevronRight } from "lucide-react";
import { BRAND, BRAND_BG, BRAND_BORDER, cardBase } from "../theme/colors";

interface MenuButtonProps {
  icon: React.ElementType;
  title: string;
  subtitle?: string;
  badge?: string;
  onClick: () => void;
}

const MenuButton: React.FC<MenuButtonProps> = ({
  icon: Icon,
  title,
  subtitle,
  badge,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      style={{
        ...cardBase,
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "14px 16px",
        cursor: "pointer",
        textAlign: "left",
        transition: "all .2s",
      }}
      onMouseEnter={(e) => {
        const el = e.currentTarget as HTMLElement;
        el.style.borderColor = BRAND;
        el.style.background = BRAND_BG;
      }}
      onMouseLeave={(e) => {
        const el = e.currentTarget as HTMLElement;
        el.style.borderColor = "var(--border)";
        el.style.background = "var(--card)";
      }}>
      <div
        style={{
          width: 38,
          height: 38,
          borderRadius: 8,
          background: BRAND_BG,
          border: `1px solid ${BRAND_BORDER}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}>
        <Icon size={18} style={{ color: BRAND }} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ color: "#fff", fontWeight: 700, fontSize: 14 }}>{title}</p>
        {subtitle && (
          <p style={{ color: "var(--muted)", fontSize: 11, marginTop: 2 }}>
            {subtitle}
          </p>
        )}
      </div>
      {badge ?
        <span
          style={{
            padding: "3px 8px",
            borderRadius: 999,
            fontSize: 10,
            fontWeight: 700,
            background: BRAND_BG,
            color: BRAND,
            whiteSpace: "nowrap",
            letterSpacing: ".3px",
          }}>
          {badge}
        </span>
      : <ChevronRight size={16} style={{ color: "var(--muted)" }} />}
    </button>
  );
};

export default MenuButton;
